
(() => {
  const allowed = [
    ['manual', 'Featured'],
    ['best-selling', 'Best selling'],
    ['price-ascending', 'Price: Low to High'],
    ['price-descending', 'Price: High to Low']
  ];

  function init() {
    const mobileDrawer = document.querySelector('.mobile-facets__wrapper');
    const mobileSummary = mobileDrawer?.querySelector(
      '.mobile-facets__disclosure > summary'
    );
    const mobileSelect = document.querySelector('#SortBy-mobile');
    const desktopSelects = document.querySelectorAll(
      '#SortBy, #SortBy-mobile'
    );

    if (!mobileDrawer || !mobileSummary || !mobileSelect) return;

    // Keep Shopify's original selects and sorting events intact.
    desktopSelects.forEach(select => {
      if (select.dataset.lpSortReady) return;
      select.dataset.lpSortReady = 'true';

      Array.from(select.options).forEach(option => {
        if (!allowed.some(([value]) => value === option.value)) {
          option.disabled = true;
          option.hidden = true;
        }
      });
    });

    if (mobileDrawer.dataset.lpSortOnly === 'true') return;
    mobileDrawer.dataset.lpSortOnly = 'true';

    const panel = document.createElement('div');
    panel.className = 'lp-mobile-sort-panel';
    panel.hidden = true;
    panel.setAttribute('aria-label', 'Sort products');

    allowed.forEach(([value, label]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lp-mobile-sort-option';
      button.textContent = label;

      button.addEventListener('click', () => {
        mobileSelect.value = value;
        mobileSelect.dispatchEvent(new Event('input', { bubbles: true }));
        panel.hidden = true;
        mobileSummary.setAttribute('aria-expanded', 'false');
      });

      panel.appendChild(button);
    });

    mobileSummary.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();

      panel.hidden = !panel.hidden;
      mobileSummary.setAttribute(
        'aria-expanded',
        String(!panel.hidden)
      );
    });

    mobileDrawer.appendChild(panel);
  }

  function start() {
    init();

    new MutationObserver(() => init()).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
